import { Component, OnInit } from '@angular/core';
import { TenantService } from '../../../../Services/tenant.service';
import { MatButton } from '@angular/material/button';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.css'],
    imports: [MatButton, RouterLinkActive, RouterLink, MatIcon]
})

export class ImportComponent implements OnInit {
    public hasReleases: boolean = false;
    public selectedTenant: any;

    constructor(private tenantService: TenantService) { }

    public ngOnInit(): void {
        this.selectedTenant = this.tenantService.selectedTenant;
    }
}
